import { Box, Divider } from '@mui/material';
import { FormProvider } from 'react-hook-form';

import { LoadingBar, StyledContentLayout } from '@/components';

import { ActionButtonGroups, UserImages, UserProfileForm } from '../components';
import { useGetUserProfile, useUserProfileForm } from '../hooks';

export const UserProfile = () => {
  const form = useUserProfileForm();
  const { isLoading } = useGetUserProfile({ reset: form.reset });

  if (isLoading) return <LoadingBar />;

  return (
    <Box bgcolor="#FFF" height="100%">
      <StyledContentLayout fixedHeight>
        <FormProvider {...form}>
          <ActionButtonGroups position="top" />
          <Divider />
          <UserProfileForm />
          <Divider sx={{ marginY: '1em' }} />
          <UserImages />
          <Divider />
          <ActionButtonGroups position="bottom" />
        </FormProvider>
      </StyledContentLayout>
    </Box>
  );
};
